module.exports = __webpack_public_path__ + "media/images/bg-service-intro-bc8588131dcb7cc72409163d5b2312ea.svg";